export default __webpack_public_path__ + "static/media/StuonB5.18543220.png";